export default __webpack_public_path__ + "static/media/11.40b12f8e.png";